module.exports = __webpack_public_path__ + "img/Backfee.e0d56ecb.jpg";